import { g as I } from "./_commonjsHelpers.DaMA6jEr.js";
import { f as O, g as M, c as w, h as S, i as F } from "./_getTag.B1GM_Sq5.js";
import { a as R, _ as l, k as b, b as x, c as D } from "./_baseIsEqual.CLFNswVP.js";
import { i as o } from "./isArray.CAJdVVdL.js";
import { i as m } from "./isSymbol.CZPCZPYP.js";
import { t as K } from "./toString.Cx3TcJvA.js";
var L = R, B = l, G = 1, T = 2;
function N(r, e, a, n) {
  var t = a.length, i = t, s = !n;
  if (r == null)
    return !i;
  for (r = Object(r); t--; ) {
    var u = a[t];
    if (s && u[2] ? u[1] !== r[u[0]] : !(u[0] in r))
      return !1;
  }
  for (; ++t < i; ) {
    u = a[t];
    var f = u[0], h = r[f], p = u[1];
    if (s && u[2]) {
      if (h === void 0 && !(f in r))
        return !1;
    } else {
      var _ = new L();
      if (n)
        var y = n(h, p, f, r, e, _);
      if (!(y === void 0 ? B(p, h, G | T, n, _) : y))
        return !1;
    }
  }
  return !0;
}
var z = N, q = O;
function H(r) {
  return r === r && !q(r);
}
var A = H, U = A, X = b;
function Z(r) {
  for (var e = X(r), a = e.length; a--; ) {
    var n = e[a], t = r[n];
    e[a] = [n, t, U(t)];
  }
  return e;
}
var k = Z;
function J(r, e) {
  return function(a) {
    return a == null ? !1 : a[r] === e && (e !== void 0 || r in Object(a));
  };
}
var P = J, Q = z, W = k, Y = P;
function V(r) {
  var e = W(r);
  return e.length == 1 && e[0][2] ? Y(e[0][0], e[0][1]) : function(a) {
    return a === r || Q(a, r, e);
  };
}
var j = V, rr = o, er = m, ar = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, nr = /^\w*$/;
function tr(r, e) {
  if (rr(r))
    return !1;
  var a = typeof r;
  return a == "number" || a == "symbol" || a == "boolean" || r == null || er(r) ? !0 : nr.test(r) || !ar.test(r) || e != null && r in Object(e);
}
var v = tr, d = x, ir = "Expected a function";
function c(r, e) {
  if (typeof r != "function" || e != null && typeof e != "function")
    throw new TypeError(ir);
  var a = function() {
    var n = arguments, t = e ? e.apply(this, n) : n[0], i = a.cache;
    if (i.has(t))
      return i.get(t);
    var s = r.apply(this, n);
    return a.cache = i.set(t, s) || i, s;
  };
  return a.cache = new (c.Cache || d)(), a;
}
c.Cache = d;
var sr = c, ur = sr, fr = 500;
function or(r) {
  var e = ur(r, function(n) {
    return a.size === fr && a.clear(), n;
  }), a = e.cache;
  return e;
}
var gr = or, hr = gr, vr = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, cr = /\\(\\)?/g, pr = hr(function(r) {
  var e = [];
  return r.charCodeAt(0) === 46 && e.push(""), r.replace(vr, function(a, n, t, i) {
    e.push(t ? i.replace(cr, "$1") : n || a);
  }), e;
}), _r = pr, yr = o, $r = v, lr = _r, br = K;
function mr(r, e) {
  return yr(r) ? r : $r(r, e) ? [r] : lr(br(r));
}
var E = mr, Ar = m;
function Pr(r) {
  if (typeof r == "string" || Ar(r))
    return r;
  var e = r + "";
  return e == "0" && 1 / r == -1 / 0 ? "-0" : e;
}
var g = Pr, dr = E, Er = g;
function Cr(r, e) {
  e = dr(e, r);
  for (var a = 0, n = e.length; r != null && a < n; )
    r = r[Er(e[a++])];
  return a && a == n ? r : void 0;
}
var C = Cr, Ir = C;
function Or(r, e, a) {
  var n = r == null ? void 0 : Ir(r, e);
  return n === void 0 ? a : n;
}
var Mr = Or;
function wr(r, e) {
  return r != null && e in Object(r);
}
var Sr = wr, Fr = E, Rr = w, xr = o, Dr = D, Kr = M, Lr = g;
function Br(r, e, a) {
  e = Fr(e, r);
  for (var n = -1, t = e.length, i = !1; ++n < t; ) {
    var s = Lr(e[n]);
    if (!(i = r != null && a(r, s)))
      break;
    r = r[s];
  }
  return i || ++n != t ? i : (t = r == null ? 0 : r.length, !!t && Kr(t) && Dr(s, t) && (xr(r) || Rr(r)));
}
var Gr = Br, Tr = Sr, Nr = Gr;
function zr(r, e) {
  return r != null && Nr(r, e, Tr);
}
var qr = zr, Hr = l, Ur = Mr, Xr = qr, Zr = v, kr = A, Jr = P, Qr = g, Wr = 1, Yr = 2;
function Vr(r, e) {
  return Zr(r) && kr(e) ? Jr(Qr(r), e) : function(a) {
    var n = Ur(a, r);
    return n === void 0 && n === e ? Xr(a, r) : Hr(e, n, Wr | Yr);
  };
}
var jr = Vr;
function re(r) {
  return r;
}
var ee = re;
function ae(r) {
  return function(e) {
    return e?.[r];
  };
}
var ne = ae, te = C;
function ie(r) {
  return function(e) {
    return te(e, r);
  };
}
var se = ie, ue = ne, fe = se, oe = v, ge = g;
function he(r) {
  return oe(r) ? ue(ge(r)) : fe(r);
}
var ve = he, ce = j, pe = jr, _e = ee, ye = o, $e = ve;
function le(r) {
  return typeof r == "function" ? r : r == null ? _e : typeof r == "object" ? ye(r) ? pe(r[0], r[1]) : ce(r) : $e(r);
}
var be = le, me = S, Ae = function() {
  try {
    var r = me(Object, "defineProperty");
    return r({}, "", {}), r;
  } catch {
  }
}(), Pe = Ae, $ = Pe;
function de(r, e, a) {
  e == "__proto__" && $ ? $(r, e, {
    configurable: !0,
    enumerable: !0,
    value: a,
    writable: !0
  }) : r[e] = a;
}
var Ee = de;
function Ce(r, e, a, n) {
  for (var t = -1, i = r == null ? 0 : r.length; ++t < i; ) {
    var s = r[t];
    e(n, s, a(s), r);
  }
  return n;
}
var Ie = Ce;
function Oe(r) {
  return function(e, a, n) {
    for (var t = -1, i = Object(e), s = n(e), u = s.length; u--; ) {
      var f = s[r ? u : ++t];
      if (a(i[f], f, i) === !1)
        break;
    }
    return e;
  };
}
var Me = Oe, we = Me, Se = we(), Fe = Se, Re = Fe, xe = b;
function De(r, e) {
  return r && Re(r, e, xe);
}
var Ke = De, Le = F;
function Be(r, e) {
  return function(a, n) {
    if (a == null)
      return a;
    if (!Le(a))
      return r(a, n);
    for (var t = a.length, i = e ? t : -1, s = Object(a); (e ? i-- : ++i < t) && n(s[i], i, s) !== !1; )
      ;
    return a;
  };
}
var Ge = Be, Te = Ke, Ne = Ge, ze = Ne(Te), qe = ze, He = qe;
function Ue(r, e, a, n) {
  return He(r, function(t, i, s) {
    e(n, t, a(t), s);
  }), n;
}
var Xe = Ue, Ze = Ie, ke = Xe, Je = be, Qe = o;
function We(r, e) {
  return function(a, n) {
    var t = Qe(a) ? Ze : ke, i = e ? e() : {};
    return t(a, r, Je(n), i);
  };
}
var Ye = We, Ve = Ee, je = Ye, ra = Object.prototype, ea = ra.hasOwnProperty, aa = je(function(r, e, a) {
  ea.call(r, a) ? r[a].push(e) : Ve(r, a, [e]);
}), na = aa;
const ga = /* @__PURE__ */ I(na);
export {
  be as _,
  ga as g
};
//# sourceMappingURL=groupBy.BfGV0C80.js.map
